module.exports = __webpack_public_path__ + "static/img/65073F_1_R_20201130_LC.2b2e6ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/65073F_1_R_20201130_LC.png
// module id = tlNv
// module chunks = 0